import React, { useState, useEffect } from 'react'
import { deleteEvent, getAllEvents } from '../Context/firebase'

import Event from '../Components/MyEvent/MyEventComponent'
import { Nav, Panel, FlexboxGrid, Loader } from 'rsuite'
import { Link } from 'react-router-dom'

import { fonts } from '../Components/Styles/common-styles'

import { H1, Image, Title, FlexWrapper } from '../Components/MyEvent/MyEventStyledComponents'
import '../Components/Styles/navigation-bar.css'

const styles = {
  navStyle: {
    margin: '5px auto'
  },
  navtext: {
    textTransform: 'capitalize',
    margin: 'auto 68px auto auto',
    padding: '8px 12px 8px 0'
  }
}

export default function Events () {
  const [activeTab, setActiveTab] = useState('upcoming')
  const [events, setEvents] = useState(null)
  const [isDeleted, setDeleted] = useState(false)
  const [error, setError] = useState()

  const handleSelect = (activeKey) => {
    setActiveTab(activeKey)
  }

  useEffect(() => {
    getAllEvents().then(data => {
      setEvents(data)
    })
  }, [])

  async function handleDelete (props) {
    const eventId = props.target.value
    try {
      console.log('try to delete' + eventId)
      await deleteEvent(eventId)
      setDeleted(true)
    } catch (error) {
      console.error(error)
      return setError('Unable to Delete')
    }
    setError('')
  }

  // useEffect for rendering cards after delete
  useEffect(() => {
    if (isDeleted === true) {
      getAllEvents().then(data => {
        setEvents(data)
      })
      setDeleted(false)
    }
  }, [isDeleted])

  const displayedEvents = events
    ? events.filter(event => {
      if (activeTab === 'upcoming') {
        return event.date - Date.now() >= 0
      } else if (activeTab === 'past') {
        return event.date - Date.now() < 0
      } else if (activeTab === 'all') {
        return true
      } else {
        return false
      }
    })
    : []

  return (
    <FlexboxGrid justify='center' style={{ margin: '26px 20px 20px 28px' }}>
      <FlexboxGrid.Item colspan={24}>
        <H1 style={{ fontSize: 'fonts.extraLargeSize', paddingLeft: '12px' }}> My events</H1>
      </FlexboxGrid.Item>
      <FlexboxGrid.Item colspan={24}>
        <CustomNav style={styles.navStyle} appearance='subtle' active={activeTab} onSelect={(e) => { handleSelect(e) }} />
        {error && <div>{error}</div>}
        {
          !events
            ? <Loader />
            : displayedEvents.length
              ? displayedEvents.map(event => <Event key={event.id} {...event} handleDelete={(e) => handleDelete(e)} />)
              : <EmptyEvents value={activeTab} />
        }
      </FlexboxGrid.Item>
    </FlexboxGrid>
  )
}

const EmptyEvents = (tab) => {
  const message =
    {
      all: 'All your events will be stored here. But it’s a bit empty at the moment... So, let’s',
      upcoming: 'Your calendar seems empty with no upcoming events in it. So, let’s',
      past: 'Events that you completed will be stored here so you can revisit them. But for now let’s'
    }

  return (
    <Panel shaded>
      <FlexboxGrid justify='center'>
        <FlexWrapper>
          <Title style={{ display: 'block ', maxWidth: '614px', margin: '5% auto', textAlign: 'center', lineHeight: '34.2px', fontSize: fonts.largePlusSize }}>
            {message[tab.value]}
            <Link to='/create' style={{ fontWeight: '600' }}> create a new one</Link>
          </Title>
          <Image style={{ margin: '3% auto', width: '358px', height: '302.94px' }} src='/Images/Empty-state.svg' />
        </FlexWrapper>
      </FlexboxGrid>
    </Panel>
  )
}

const CustomNav = ({ active, onSelect, ...props }) => {
  const tabs = ['upcoming', 'past', 'all']
  return (
    <Nav {...props} activeKey={active} onSelect={onSelect} style={styles.navStyle}>
      {tabs.map((tab, i) => <Nav.Item
        key={i}
        eventKey={tab}
        style={styles.navtext}
      >

        <span style={{ fontSize: fonts.bigSize }}>{tab}</span></Nav.Item>)}
    </Nav>
  )
}
